import {
    ActionService, collection,
    ConfigurationService,
    EntityData,
    JwtHttpClientService,
    ResourceModule
} from "@fedeltapointofsale/data-client";
import {Inject, Injectable} from "@angular/core";
import {ProductCountDownData} from "./product-count-down.data";

export class AppItemManageProductCountdownAction extends EntityData<ProductCountDownData> {
    @collection(ProductCountDownData) public countdowns: ProductCountDownData[] = [];
}

/**
 * Action Service to manage product countdown settings
 */
@Injectable()
export class AppItemManageProductCountdownService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        super(http, configService, nameSpace, actionNames, "app-item-manage-product-countdown");
    }
}
